import mongoose from 'mongoose';
import schema, { ITripHeartBoostDocument } from '../schemas/trip-heart-boost';

const TripHeartBoost = (mongoose.models.TripHeartBoost ||
  mongoose.model('TripHeartBoost', schema)) as mongoose.Model<ITripHeartBoostDocument>;

export default TripHeartBoost;
